module.exports = [
  {
    id: '200,299',
    name: 'Успешный запрос'
  },
  {
    id: '300,399',
    name: 'Перенаправление'
  },
  {
    id: '400,499',
    name: 'Ошибка клиента'
  },
  {
    id: '500,599',
    name: 'Ошибка сервера'
  }
]
